export const MIN_ID = 0.7;
export const MAX_ID = 100;
export const MIN_OD = 1;
export const MAX_OD = 100;
export const MIN_TOP_DEPTH = -200;
export const MAX_TOP_DEPTH = 45000;
export const MIN_BOTTOM_DEPTH = -200;
export const MAX_BOTTOM_DEPTH = 55000;

export const DP_MIN_ID = 1;
export const DP_MAX_ID = 7;
export const DP_MIN_OD = 2;
export const DP_MAX_OD = 8;
export const DP_MIN_TJ_ID = 1;
export const DP_MAX_TJ_ID = 7;
export const DP_MIN_TJ_OD = 2;
export const DP_MAX_TJ_OD = 10;
export const DP_MIN_LENGTH = 0;
export const DP_MAX_LENGTH = 30000;

export const HWDP_MIN_ID = 1;
export const HWDP_MAX_ID = 7;
export const HWDP_MIN_OD = 2;
export const HWDP_MAX_OD = 8;
export const HWDP_MIN_TJ_ID = 1;
export const HWDP_MAX_TJ_ID = 7;
export const HWDP_MIN_TJ_OD = 2;
export const HWDP_MAX_TJ_OD = 10;
export const HWDP_MIN_LENGTH = 0;
export const HWDP_MAX_LENGTH = 5000;

export const COMPONENT_FAMILIES = [
  { name: 'DP', type: 'dp' },
  { name: 'HWDP', type: 'hwdp' },
  { name: 'Casing Joints', type: 'casing_joints' },
  { name: 'XO', type: 'cross_over' },
  { name: 'Marker Joint', type: 'marker_point' },
  { name: 'Pup Joint', type: 'pup' },
  { name: 'Toe Sleeve', type: 'toe_sleeve' },
  { name: 'Other', type: 'other' },
  { name: 'Air Lock Sub', type: 'air_lock_sub' },
  { name: 'Float Collar', type: 'float_collar' },
  { name: 'Float Shoe', type: 'float_shoe' },
  { name: 'Riser', type: 'riser' },
  { name: 'Liner Top Packer', type: 'liner_top_packer' },
  { name: 'Liner Hanger', type: 'liner_hanger' },
  { name: 'DV Tool', type: 'dv_tool' },
  { name: 'ACP', type: 'acp' },
  { name: 'PBR', type: 'pbr' },
];

export const COMPONENT_CLASSES = [
  { name: 'New', type: 'New' },
  { name: 'Premium', type: 'Premium' },
  { name: 'Class 2', type: 'Class 2' },
  { name: '10% Wear', type: '10% Wear' },
];

export const COMPONENT_MATERIALS = [
  { name: 'Steel', type: 'Steel' },
  { name: 'Aluminium', type: 'Aluminium' },
  { name: 'Titanium', type: 'Titanium' },
  { name: 'Non Magnetic', type: 'Non Magnetic' },
];

export const COMPONENT_GRADES = [
  { name: 'H-40', type: 'H-40' },
  { name: 'J-55', type: 'J-55' },
  { name: 'K-55', type: 'K-55' },
  { name: 'N-80', type: 'N-80' },
  { name: 'L-80', type: 'L-80' },
  { name: 'C-90', type: 'C-90' },
  { name: 'C-95', type: 'C-95' },
  { name: 'T-95', type: 'T-95' },
  { name: 'P-110', type: 'P-110' },
  { name: 'Q-125', type: 'Q-125' },
];

export const OD_ID_DEP_UNITS = {
  outer_diameter: {
    unitType: 'shortLength',
    unitImperial: 'in',
  },
  inner_diameter: {
    unitType: 'shortLength',
    unitImperial: 'in',
  },
  linear_weight: {
    unitType: 'massPerLength',
    unitImperial: 'lb-ft',
  },
};

export const OD_ID_DEP_LABELS = {
  outer_diameter: 'Outer Diameter',
  inner_diameter: 'Inner Diameter',
  linear_weight: 'Adjusted Linear Weight',
  number_of_joints: '# of Joints',
  component_length: 'Component Length',
};

export const OD_ID_DEP_LIST = [
  {
    outer_diameter: 4.5,
    inner_diameter: 4.09,
    linear_weight: 9.5,
    number_of_joints: 1,
    component_length: 42,
    key: 0,
  },
  {
    outer_diameter: 4.5,
    inner_diameter: 4.0,
    linear_weight: 11.6,
    number_of_joints: 1,
    component_length: 42,
    key: 1,
  },
  {
    outer_diameter: 4.5,
    inner_diameter: 3.92,
    linear_weight: 13.5,
    number_of_joints: 1,
    component_length: 42,
    key: 2,
  },
  {
    outer_diameter: 4.5,
    inner_diameter: 3.826,
    linear_weight: 15.1,
    number_of_joints: 1,
    component_length: 42,
    key: 3,
  },
  {
    outer_diameter: 5,
    inner_diameter: 4.56,
    linear_weight: 11.5,
    number_of_joints: 1,
    component_length: 42,
    key: 4,
  },
  {
    outer_diameter: 5,
    inner_diameter: 4.494,
    linear_weight: 13.0,
    number_of_joints: 1,
    component_length: 42,
    key: 5,
  },
  {
    outer_diameter: 5,
    inner_diameter: 4.408,
    linear_weight: 15.0,
    number_of_joints: 1,
    component_length: 42,
    key: 6,
  },
  {
    outer_diameter: 5,
    inner_diameter: 4.276,
    linear_weight: 18.0,
    number_of_joints: 1,
    component_length: 42,
    key: 7,
  },
  {
    outer_diameter: 5.5,
    inner_diameter: 5.012,
    linear_weight: 14.0,
    number_of_joints: 1,
    component_length: 42,
    key: 8,
  },
  {
    outer_diameter: 5.5,
    inner_diameter: 4.95,
    linear_weight: 15.5,
    number_of_joints: 1,
    component_length: 42,
    key: 9,
  },
  {
    outer_diameter: 5.5,
    inner_diameter: 5.044,
    linear_weight: 13.0,
    number_of_joints: 1,
    component_length: 42,
    key: 10,
  },
  {
    outer_diameter: 5.5,
    inner_diameter: 4.892,
    linear_weight: 17.0,
    number_of_joints: 1,
    component_length: 42,
    key: 11,
  },
  {
    outer_diameter: 5.5,
    inner_diameter: 4.778,
    linear_weight: 20.0,
    number_of_joints: 1,
    component_length: 42,
    key: 12,
  },
  {
    outer_diameter: 5.5,
    inner_diameter: 4.67,
    linear_weight: 23.0,
    number_of_joints: 1,
    component_length: 42,
    key: 13,
  },
  {
    outer_diameter: 6,
    inner_diameter: 5.524,
    linear_weight: 15.0,
    number_of_joints: 1,
    component_length: 42,
    key: 14,
  },
  {
    outer_diameter: 6,
    inner_diameter: 5.424,
    linear_weight: 18.0,
    number_of_joints: 1,
    component_length: 42,
    key: 15,
  },
  {
    outer_diameter: 6,
    inner_diameter: 5.352,
    linear_weight: 20.0,
    number_of_joints: 1,
    component_length: 42,
    key: 16,
  },
  {
    outer_diameter: 6,
    inner_diameter: 5.24,
    linear_weight: 23.0,
    number_of_joints: 1,
    component_length: 42,
    key: 17,
  },
  {
    outer_diameter: 6,
    inner_diameter: 5.132,
    linear_weight: 26.0,
    number_of_joints: 1,
    component_length: 42,
    key: 18,
  },
  {
    outer_diameter: 6.625,
    inner_diameter: 5.675,
    linear_weight: 32,
    number_of_joints: 1,
    component_length: 42,
    key: 19,
  },
  {
    outer_diameter: 6.625,
    inner_diameter: 6.135,
    linear_weight: 17.0,
    number_of_joints: 1,
    component_length: 42,
    key: 20,
  },
  {
    outer_diameter: 6.625,
    inner_diameter: 6.049,
    linear_weight: 20.0,
    number_of_joints: 1,
    component_length: 42,
    key: 21,
  },
  {
    outer_diameter: 6.625,
    inner_diameter: 5.921,
    linear_weight: 24.0,
    number_of_joints: 1,
    component_length: 42,
    key: 22,
  },
  {
    outer_diameter: 6.625,
    inner_diameter: 5.791,
    linear_weight: 28.0,
    number_of_joints: 1,
    component_length: 42,
    key: 23,
  },
  {
    outer_diameter: 7,
    inner_diameter: 6.538,
    linear_weight: 17.0,
    number_of_joints: 1,
    component_length: 42,
    key: 24,
  },
  {
    outer_diameter: 7,
    inner_diameter: 6.456,
    linear_weight: 20.0,
    number_of_joints: 1,
    component_length: 42,
    key: 25,
  },
  {
    outer_diameter: 7,
    inner_diameter: 6.366,
    linear_weight: 23.0,
    number_of_joints: 1,
    component_length: 42,
    key: 26,
  },
  {
    outer_diameter: 7,
    inner_diameter: 6.276,
    linear_weight: 26.0,
    number_of_joints: 1,
    component_length: 42,
    key: 27,
  },
  {
    outer_diameter: 7,
    inner_diameter: 6.184,
    linear_weight: 29.0,
    number_of_joints: 1,
    component_length: 42,
    key: 28,
  },
  {
    outer_diameter: 7,
    inner_diameter: 6.094,
    linear_weight: 32.0,
    number_of_joints: 1,
    component_length: 42,
    key: 29,
  },
  {
    outer_diameter: 7,
    inner_diameter: 6.004,
    linear_weight: 35.0,
    number_of_joints: 1,
    component_length: 42,
    key: 30,
  },
  {
    outer_diameter: 7,
    inner_diameter: 5.92,
    linear_weight: 38.0,
    number_of_joints: 1,
    component_length: 42,
    key: 31,
  },
  {
    outer_diameter: 7.625,
    inner_diameter: 7.125,
    linear_weight: 20.0,
    number_of_joints: 1,
    component_length: 42,
    key: 32,
  },
  {
    outer_diameter: 7.625,
    inner_diameter: 7.025,
    linear_weight: 24.0,
    number_of_joints: 1,
    component_length: 42,
    key: 33,
  },
  {
    outer_diameter: 7.625,
    inner_diameter: 6.969,
    linear_weight: 26.4,
    number_of_joints: 1,
    component_length: 42,
    key: 34,
  },
  {
    outer_diameter: 7.625,
    inner_diameter: 6.875,
    linear_weight: 29.7,
    number_of_joints: 1,
    component_length: 42,
    key: 35,
  },
  {
    outer_diameter: 7.625,
    inner_diameter: 6.625,
    linear_weight: 39.0,
    number_of_joints: 1,
    component_length: 42,
    key: 36,
  },
  {
    outer_diameter: 7.625,
    inner_diameter: 6.765,
    linear_weight: 33.7,
    number_of_joints: 1,
    component_length: 42,
    key: 37,
  },
  {
    outer_diameter: 8.625,
    inner_diameter: 8.097,
    linear_weight: 24.0,
    number_of_joints: 1,
    component_length: 42,
    key: 38,
  },
  {
    outer_diameter: 8.625,
    inner_diameter: 8.017,
    linear_weight: 28.0,
    number_of_joints: 1,
    component_length: 42,
    key: 39,
  },
  {
    outer_diameter: 8.625,
    inner_diameter: 7.921,
    linear_weight: 32.0,
    number_of_joints: 1,
    component_length: 42,
    key: 40,
  },
  {
    outer_diameter: 8.625,
    inner_diameter: 7.825,
    linear_weight: 36.0,
    number_of_joints: 1,
    component_length: 42,
    key: 41,
  },
  {
    outer_diameter: 8.625,
    inner_diameter: 7.725,
    linear_weight: 40.0,
    number_of_joints: 1,
    component_length: 42,
    key: 42,
  },
  {
    outer_diameter: 8.625,
    inner_diameter: 7.625,
    linear_weight: 44.0,
    number_of_joints: 1,
    component_length: 42,
    key: 43,
  },
  {
    outer_diameter: 8.625,
    inner_diameter: 7.511,
    linear_weight: 49.0,
    number_of_joints: 1,
    component_length: 42,
    key: 44,
  },
  {
    outer_diameter: 9.625,
    inner_diameter: 9.063,
    linear_weight: 29.3,
    number_of_joints: 1,
    component_length: 42,
    key: 45,
  },
  {
    outer_diameter: 9.625,
    inner_diameter: 9.001,
    linear_weight: 32.3,
    number_of_joints: 1,
    component_length: 42,
    key: 46,
  },
  {
    outer_diameter: 9.625,
    inner_diameter: 8.921,
    linear_weight: 36.0,
    number_of_joints: 1,
    component_length: 42,
    key: 47,
  },
  {
    outer_diameter: 9.625,
    inner_diameter: 8.835,
    linear_weight: 40.0,
    number_of_joints: 1,
    component_length: 42,
    key: 48,
  },
  {
    outer_diameter: 9.625,
    inner_diameter: 8.755,
    linear_weight: 43.5,
    number_of_joints: 1,
    component_length: 42,
    key: 49,
  },
  {
    outer_diameter: 9.625,
    inner_diameter: 8.681,
    linear_weight: 47.0,
    number_of_joints: 1,
    component_length: 42,
    key: 50,
  },
  {
    outer_diameter: 9.625,
    inner_diameter: 8.535,
    linear_weight: 53.5,
    number_of_joints: 1,
    component_length: 42,
    key: 51,
  },
  {
    outer_diameter: 10.75,
    inner_diameter: 10.192,
    linear_weight: 32.8,
    number_of_joints: 1,
    component_length: 42,
    key: 52,
  },
  {
    outer_diameter: 10.75,
    inner_diameter: 10.05,
    linear_weight: 40.5,
    number_of_joints: 1,
    component_length: 42,
    key: 53,
  },
  {
    outer_diameter: 10.75,
    inner_diameter: 9.95,
    linear_weight: 45.5,
    number_of_joints: 1,
    component_length: 42,
    key: 54,
  },
  {
    outer_diameter: 10.75,
    inner_diameter: 9.85,
    linear_weight: 51.0,
    number_of_joints: 1,
    component_length: 42,
    key: 55,
  },
  {
    outer_diameter: 10.75,
    inner_diameter: 9.76,
    linear_weight: 55.5,
    number_of_joints: 1,
    component_length: 42,
    key: 56,
  },
  {
    outer_diameter: 10.75,
    inner_diameter: 9.66,
    linear_weight: 60.7,
    number_of_joints: 1,
    component_length: 42,
    key: 57,
  },
  {
    outer_diameter: 10.75,
    inner_diameter: 9.56,
    linear_weight: 65.7,
    number_of_joints: 1,
    component_length: 42,
    key: 58,
  },
  {
    outer_diameter: 11.75,
    inner_diameter: 11.15,
    linear_weight: 38.0,
    number_of_joints: 1,
    component_length: 42,
    key: 59,
  },
  {
    outer_diameter: 11.75,
    inner_diameter: 11.084,
    linear_weight: 42.0,
    number_of_joints: 1,
    component_length: 42,
    key: 60,
  },
  {
    outer_diameter: 11.75,
    inner_diameter: 11.0,
    linear_weight: 47.0,
    number_of_joints: 1,
    component_length: 42,
    key: 61,
  },
  {
    outer_diameter: 11.75,
    inner_diameter: 10.88,
    linear_weight: 54.0,
    number_of_joints: 1,
    component_length: 42,
    key: 62,
  },
  {
    outer_diameter: 11.75,
    inner_diameter: 10.772,
    linear_weight: 60.0,
    number_of_joints: 1,
    component_length: 42,
    key: 63,
  },
  {
    outer_diameter: 13.375,
    inner_diameter: 12.715,
    linear_weight: 48.0,
    number_of_joints: 1,
    component_length: 42,
    key: 64,
  },
  {
    outer_diameter: 13.375,
    inner_diameter: 12.615,
    linear_weight: 54.5,
    number_of_joints: 1,
    component_length: 42,
    key: 65,
  },
  {
    outer_diameter: 13.375,
    inner_diameter: 12.515,
    linear_weight: 61.0,
    number_of_joints: 1,
    component_length: 42,
    key: 66,
  },
  {
    outer_diameter: 13.375,
    inner_diameter: 12.415,
    linear_weight: 68.0,
    number_of_joints: 1,
    component_length: 42,
    key: 67,
  },
  {
    outer_diameter: 13.375,
    inner_diameter: 12.347,
    linear_weight: 72.0,
    number_of_joints: 1,
    component_length: 42,
    key: 68,
  },
  {
    outer_diameter: 16,
    inner_diameter: 15.375,
    linear_weight: 55.0,
    number_of_joints: 1,
    component_length: 42,
    key: 69,
  },
  {
    outer_diameter: 16,
    inner_diameter: 15.25,
    linear_weight: 65.0,
    number_of_joints: 1,
    component_length: 42,
    key: 70,
  },
  {
    outer_diameter: 16,
    inner_diameter: 15.125,
    linear_weight: 75.0,
    number_of_joints: 1,
    component_length: 42,
    key: 71,
  },
  {
    outer_diameter: 16,
    inner_diameter: 15.01,
    linear_weight: 84.0,
    number_of_joints: 1,
    component_length: 42,
    key: 72,
  },
  {
    outer_diameter: 18.625,
    inner_diameter: 17.755,
    linear_weight: 87.5,
    number_of_joints: 1,
    component_length: 42,
    key: 73,
  },
  {
    outer_diameter: 20,
    inner_diameter: 19.124,
    linear_weight: 94.0,
    number_of_joints: 1,
    component_length: 42,
    key: 74,
  },
];
